import _ from 'lodash'
import { connect } from 'react-redux'
import { Link as ReactRouterLink } from 'react-router-dom'
import React from 'react'
import { prefixPath } from 'l8n'

const mapStateToProps = (state) => ({
  locale: state.app.locale
})

@connect(mapStateToProps)
class Link extends React.Component {
  render() {
      const { to, locale, children, className, style, onClick, qaId } = this.props
      return (
          <ReactRouterLink
            to={locale.url ? prefixPath(to, locale.value) : to}
            className={className}
            data-qa-id={qaId}
            onClick={onClick}
            style={style}
          >
              {children}
          </ReactRouterLink>
      )
  }
}
export default Link



// WEBPACK FOOTER //
// ./src/components/CustomComponents/Localization/Link/index.js